// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__18mz5","backdrop":"style_backdrop__2Kjrm","dialog":"style_dialog__1ysK6","row":"style_row__3ba8S","edit":"style_edit__1_GMG"};